import {type Libraries, useLoadScript} from '@react-google-maps/api';
import {useState} from 'react';

interface Address {
  streetNumberValue: string;
  routeValue: string;
  zipCodeValue: string;
  placeId?: string;
}

const libraries: Libraries = ['places'];
const useGoogleMapsAutocomplete = (apiKey: string) => {
  const [searchResult, setSearchResult] =
    useState<google.maps.places.Autocomplete | null>(null);

  const address: Address = {
    streetNumberValue: '',
    routeValue: '',
    zipCodeValue: '',
    placeId: '',
  };
  const {isLoaded} = useLoadScript({
    googleMapsApiKey: apiKey,
    libraries: libraries,
  });

  const options = {
    componentRestrictions: {country: 'us'},
    types: ['address'],
  };

  const onLoad = (autocomplete: google.maps.places.Autocomplete) => {
    setSearchResult(autocomplete);
  };

  const PlaceChange = () => {
    if (searchResult !== null) {
      const place = searchResult.getPlace();

      if (place.address_components) {
        for (const component of place.address_components) {
          const types = component.types;
          const shortName = component.short_name;

          if (types.includes('street_number')) {
            address.streetNumberValue = shortName;
          }
          if (types.includes('route')) {
            address.routeValue = shortName;
          }
          if (types.includes('postal_code')) {
            address.zipCodeValue = shortName;
          }
        }
      }
      if (place?.place_id?.length) {
        address.placeId = place.place_id;
      }
    }
    return address;
  };

  return {
    isLoaded,
    options,
    onLoad,
    searchResult,
    PlaceChange,
  };
};

export default useGoogleMapsAutocomplete;
